<template>
  <div class="contracts">
    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-spinner"></div>
      <div class="loader-container">
        <span class="spinner" />
        <div class="loading-message">Chargement des contrats...</div>
      </div>
    </div>
    <div class="contract_action">
      <span class="contract_title">{{ $t('CONTRACT_SIDEBAR.HISTORY') }}</span>
      <button
          v-if="updatedContracts.length"
          @click="onToggleFilters"
          style="float: right; cursor: pointer"
      >
        <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M0 16C0 8.45753 0 4.68629 2.34315 2.34315C4.68629 0 8.45753 0 16 0H28C35.5425 0 39.3137 0 41.6569 2.34315C44 4.68629 44 8.45753 44 16V28C44 35.5425 44 39.3137 41.6569 41.6569C39.3137 44 35.5425 44 28 44H16C8.45753 44 4.68629 44 2.34315 41.6569C0 39.3137 0 35.5425 0 28V16Z"
              fill="#EDECF6"
          />
          <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.3499 12.75C13.0439 12.75 12.7548 13.0022 12.7598 13.4006L12.7599 13.41L12.7599 14.96C12.7599 15.0219 12.7866 15.1658 12.871 15.3528C12.9525 15.5334 13.0578 15.6873 13.1502 15.7797L13.1641 15.794L15.7241 18.494C15.7392 18.5099 15.7536 18.5264 15.7672 18.5436C15.9551 18.7802 16.1243 19.0839 16.2477 19.3933C16.3694 19.6984 16.4698 20.0667 16.4698 20.43V24C16.4698 24.4501 16.9962 24.7626 17.411 24.5147L18.3416 23.9109L18.3558 23.9019C18.3732 23.8911 18.4455 23.8276 18.5171 23.6899C18.5872 23.5554 18.6099 23.4394 18.6099 23.39V20.49C18.6099 20.1044 18.7039 19.7025 18.8543 19.3475C19.0024 18.9978 19.2282 18.6392 19.5382 18.3737L22.4084 15.84C22.4995 15.7406 22.6135 15.5726 22.7059 15.3694C22.8054 15.1508 22.8499 14.9573 22.8499 14.83V13.35C22.8499 13.0242 22.5756 12.75 22.2499 12.75H13.3499ZM11.2599 13.4142C11.2476 12.2151 12.1775 11.25 13.3499 11.25H22.2499C23.4041 11.25 24.3499 12.1958 24.3499 13.35V14.83C24.3499 15.2427 24.2243 15.6541 24.0713 15.9906C23.9169 16.3298 23.7045 16.6587 23.4681 16.9024C23.4546 16.9162 23.4407 16.9295 23.4262 16.9423L20.5157 19.5116C20.4287 19.5855 20.3215 19.7295 20.2355 19.9325C20.1508 20.1325 20.1099 20.3356 20.1099 20.49V23.39C20.1099 23.7406 19.9975 24.0946 19.8476 24.3826C19.7006 24.665 19.4705 24.9735 19.1523 25.1729L18.2181 25.7791L18.2021 25.7892C16.858 26.6141 14.9698 25.7076 14.9698 24V20.43C14.9698 20.3233 14.9353 20.1516 14.8545 19.9492C14.7809 19.7648 14.6885 19.6037 14.6099 19.4989L12.0818 16.8325C11.8377 16.5861 11.6408 16.2734 11.5038 15.9697C11.3681 15.6692 11.2599 15.308 11.2599 14.96V13.4142Z"
              fill="#483A9D"
          />
          <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M26.2096 12.1209C26.2755 11.712 26.6605 11.434 27.0694 11.4999C27.5463 11.5768 28.0573 11.6734 28.5214 11.7907C28.9696 11.9041 29.433 12.0509 29.7795 12.2477C31.9428 13.4675 32.75 15.7811 32.75 19.0004V25.0004C32.75 27.5743 32.2398 29.5712 30.9053 30.9057C29.5709 32.2402 27.574 32.7504 25 32.7504H19C16.426 32.7504 14.4291 32.2402 13.0947 30.9057C11.7602 29.5712 11.25 27.5743 11.25 25.0004V22.0004C11.25 21.5861 11.5858 21.2504 12 21.2504C12.4142 21.2504 12.75 21.5861 12.75 22.0004V25.0004C12.75 27.4264 13.2398 28.9295 14.1553 29.845C15.0709 30.7606 16.574 31.2504 19 31.2504H25C27.426 31.2504 28.9291 30.7606 29.8447 29.845C30.7602 28.9295 31.25 27.4264 31.25 25.0004V19.0004C31.25 15.9803 30.4975 14.3741 29.0418 13.5537L29.0392 13.5523C28.8759 13.4594 28.5748 13.3515 28.1536 13.245C27.7477 13.1423 27.2837 13.0539 26.8306 12.9808C26.4217 12.9148 26.1436 12.5299 26.2096 12.1209Z"
              fill="#483A9D"
          />
          <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.25 23C22.25 22.5858 22.5858 22.25 23 22.25H28C28.4142 22.25 28.75 22.5858 28.75 23C28.75 23.4142 28.4142 23.75 28 23.75H23C22.5858 23.75 22.25 23.4142 22.25 23Z"
              fill="#483A9D"
          />
          <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20.25 27C20.25 26.5858 20.5858 26.25 21 26.25H28C28.4142 26.25 28.75 26.5858 28.75 27C28.75 27.4142 28.4142 27.75 28 27.75H21C20.5858 27.75 20.25 27.4142 20.25 27Z"
              fill="#483A9D"
          />
        </svg>
      </button>
    </div>
    <div>
      <div v-if="!isLoading && updatedContracts && !updatedContracts.length" class="empty-state">
        {{ $t('CONTRACT_SIDEBAR.NO_CONTRACTS') }}
      </div>
      <div
          class="contract_card mt-2"
          v-for="(contract, index) in filteredContracts"
          :key="index"
      >
        <a
            :href="`${contract.redirectUrl}`"
            target="_blank"
            rel="noreferrer noopener nofollow"
        >
          <div class="contract_header d-flex ">
            <h3 v-if="contract.brancheProduit === 'Automobile'">{{ $t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.TYPE.AUTOMOBILE') }}</h3>
            <h3 v-else>{{ $t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.TYPE.MRH') }}</h3>
            <div
                v-if="contract.statut === 'Suspendue'"
                class="type_badge suspended"
            >
              {{ $t('CONTRACT_SIDEBAR.STATUS.SUSPENDED') }}
            </div>
            <div
                v-else-if="contract.statut === 'En cours'"
                class="type_badge pending"
            >
              {{ $t('CONTRACT_SIDEBAR.STATUS.IN_PROGRESS') }}
            </div>
          </div>
          <div class="contract_body">
            <div class="num_contract d-flex">
              <h4>N°{{ contract.numPolice }}</h4>
              <svg
                  v-if="contract.brancheProduit === 'Automobile'"
                  width="25"
                  height="28"
                  viewBox="0 0 27 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.52051 8.11747C5.19023 7.42945 6.15185 7.10742 7.42591 7.10742H13.7959C15.071 7.10742 16.0291 7.42995 16.6983 8.11746C17.3327 8.76913 17.5727 9.62185 17.7278 10.3356L17.7292 10.3419L17.7292 10.342L18.7566 15.2373C18.8127 15.5046 18.7453 15.7829 18.5732 15.9949C18.401 16.2069 18.1425 16.3301 17.8694 16.3301H3.36457C3.09146 16.3301 2.83292 16.2069 2.66078 15.9949C2.48864 15.7829 2.42125 15.5046 2.47735 15.2373L3.50391 10.3461C3.64844 9.62473 3.88427 8.77109 4.52051 8.11747ZM5.81972 9.38213C5.57183 9.6368 5.4145 10.0382 5.28094 10.7059L5.27926 10.7144L5.27922 10.7144L4.48113 14.517H16.7528L15.9554 10.7176C15.8086 10.0432 15.6498 9.63966 15.3991 9.38213C15.183 9.16006 14.7692 8.92052 13.7959 8.92052H7.42591C6.45173 8.92052 6.0354 9.16056 5.81972 9.38213Z"
                    fill="#483A9D"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.93762 17.9738L2.42933 23.5045C2.37779 24.0084 2.78813 24.4881 3.3647 24.4881H5.06902C5.26016 24.4881 5.35881 24.468 5.40226 24.4548C5.40338 24.4525 5.40457 24.45 5.40582 24.4473C5.43056 24.3939 5.45426 24.3248 5.50036 24.1832L5.50233 24.1772L5.68518 23.6287C5.6907 23.6124 5.69643 23.5954 5.70238 23.5777C5.80385 23.2755 5.97367 22.7698 6.38241 22.3842C6.85635 21.9371 7.49738 21.7684 8.27217 21.7684H12.9137C13.6643 21.7684 14.3069 21.9112 14.7874 22.355C15.1963 22.7327 15.3696 23.2431 15.4777 23.5615C15.4852 23.5836 15.4924 23.6048 15.4994 23.6249L15.5022 23.6333L15.6805 24.168C15.7296 24.3057 15.7542 24.3739 15.7818 24.4314C15.7863 24.4407 15.7901 24.4481 15.7932 24.4539C15.8328 24.467 15.9274 24.4881 16.1168 24.4881H17.8212C18.3869 24.4881 18.8023 24.0166 18.7557 23.4957C18.7557 23.4952 18.7557 23.4948 18.7556 23.4943L18.2364 17.9762C18.2363 17.9756 18.2363 17.9751 18.2362 17.9746C18.1673 17.2678 18.0775 16.9269 17.9042 16.721C17.7756 16.5682 17.4421 16.317 16.3707 16.317H4.8031C3.73173 16.317 3.3982 16.5682 3.26956 16.721C3.09632 16.9268 3.0065 17.2676 2.93762 17.9738ZM15.7696 24.4435C15.7699 24.4433 15.773 24.4447 15.7783 24.4483C15.7719 24.4455 15.7693 24.4437 15.7696 24.4435ZM1.88246 15.5534C2.50928 14.8087 3.49326 14.5039 4.8031 14.5039H16.3707C17.6805 14.5039 18.6645 14.8087 19.2913 15.5534C19.8733 16.2448 19.9769 17.1425 20.041 17.8005L20.0412 17.8034L20.5613 23.3302C20.7073 24.9361 19.4306 26.3012 17.8212 26.3012H16.1168C15.5064 26.3012 14.96 26.1693 14.5469 25.7771C14.2093 25.4566 14.0628 25.0358 13.9875 24.8194C13.9811 24.801 13.9752 24.784 13.9698 24.7688L13.9635 24.7506L13.7836 24.2109C13.7164 24.0159 13.6753 23.8991 13.6299 23.8038C13.5895 23.7187 13.5646 23.6938 13.5572 23.6869C13.5532 23.6831 13.5291 23.6605 13.4458 23.6363C13.3505 23.6086 13.1864 23.5815 12.9137 23.5815H8.27217C7.75155 23.5815 7.63739 23.6926 7.62709 23.7026C7.6269 23.7028 7.62722 23.7025 7.62709 23.7026C7.57943 23.7476 7.53245 23.8275 7.40293 24.209L7.22344 24.7474C7.21929 24.7602 7.2149 24.7739 7.21023 24.7885C7.13781 25.0152 6.99815 25.4523 6.64507 25.7844C6.22748 26.1773 5.67454 26.3012 5.06902 26.3012H3.3647C1.76722 26.3012 0.462289 24.9463 0.625077 23.3251L1.13281 17.8005C1.19686 17.1425 1.30043 16.2448 1.88246 15.5534Z"
                    fill="#483A9D"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.53906 12.7034C1.53906 12.2028 1.94494 11.7969 2.44561 11.7969H3.35216C3.85284 11.7969 4.25871 12.2028 4.25871 12.7034C4.25871 13.2041 3.85284 13.61 3.35216 13.61H2.44561C1.94494 13.61 1.53906 13.2041 1.53906 12.7034Z"
                    fill="#483A9D"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.9512 12.7034C16.9512 12.2028 17.357 11.7969 17.8577 11.7969H18.7643C19.2649 11.7969 19.6708 12.2028 19.6708 12.7034C19.6708 13.2041 19.2649 13.61 18.7643 13.61H17.8577C17.357 13.61 16.9512 13.2041 16.9512 12.7034Z"
                    fill="#483A9D"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.25977 19.0501C4.25977 18.5494 4.66564 18.1436 5.16632 18.1436H7.88597C8.38664 18.1436 8.79252 18.5494 8.79252 19.0501C8.79252 19.5508 8.38664 19.9567 7.88597 19.9567H5.16632C4.66564 19.9567 4.25977 19.5508 4.25977 19.0501Z"
                    fill="#483A9D"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.418 19.0501C12.418 18.5494 12.8238 18.1436 13.3245 18.1436H16.0442C16.5448 18.1436 16.9507 18.5494 16.9507 19.0501C16.9507 19.5508 16.5448 19.9567 16.0442 19.9567H13.3245C12.8238 19.9567 12.418 19.5508 12.418 19.0501Z"
                    fill="#483A9D"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M22.0805 6.08335C21.3265 4.94708 20.1176 4.22529 18.8967 4.24249C18.3961 4.24954 17.996 4.66109 18.003 5.16172C18.0101 5.66234 18.4216 6.06246 18.9222 6.05541C19.4166 6.04845 20.0921 6.36472 20.5711 7.08794L20.5711 7.08796L20.5757 7.0947C21.0665 7.82156 21.0986 8.56004 20.9053 9.00876C20.7073 9.46859 20.9195 10.0019 21.3793 10.2C21.8391 10.3981 22.3724 10.1859 22.5705 9.72607C23.0536 8.60455 22.8449 7.21733 22.0805 6.08335Z"
                    fill="#483A9D"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18.3358 1.11149C18.3964 0.614491 18.8483 0.260663 19.3453 0.321195C21.5193 0.585969 23.6775 1.9349 25.1022 4.06536C26.5254 6.1935 26.9567 8.69972 26.3704 10.8075C26.2362 11.2899 25.7364 11.5721 25.2541 11.438C24.7717 11.3038 24.4894 10.804 24.6236 10.3216C25.0527 8.77906 24.7586 6.81306 23.5951 5.07326C22.4332 3.33577 20.7235 2.31554 19.1261 2.12099C18.6291 2.06046 18.2753 1.60849 18.3358 1.11149Z"
                    fill="#483A9D"
                />
              </svg>
              <svg
                  v-else-if="contract.brancheProduit === 'Risques divers' || contract.brancheProduit === 'Incendie'"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M22 22.75H2C1.59 22.75 1.25 22.41 1.25 22C1.25 21.59 1.59 21.25 2 21.25H22C22.41 21.25 22.75 21.59 22.75 22C22.75 22.41 22.41 22.75 22 22.75Z"
                    fill="#483A9D"
                />
                <path
                    d="M3.7002 22H2.2002L2.2502 9.96996C2.2502 9.11996 2.6402 8.32998 3.3102 7.80998L10.3102 2.35997C11.3002 1.58997 12.6902 1.58997 13.6902 2.35997L20.6902 7.79997C21.3502 8.31997 21.7502 9.12996 21.7502 9.96996V22H20.2502V9.97997C20.2502 9.59997 20.0702 9.22998 19.7702 8.98998L12.7702 3.54997C12.3202 3.19997 11.6902 3.19997 11.2302 3.54997L4.2302 8.99999C3.9302 9.22999 3.7502 9.59997 3.7502 9.97997L3.7002 22Z"
                    fill="#483A9D"
                />
                <path
                    d="M17 22.75H7C6.59 22.75 6.25 22.41 6.25 22V12.5C6.25 11.26 7.26 10.25 8.5 10.25H15.5C16.74 10.25 17.75 11.26 17.75 12.5V22C17.75 22.41 17.41 22.75 17 22.75ZM7.75 21.25H16.25V12.5C16.25 12.09 15.91 11.75 15.5 11.75H8.5C8.09 11.75 7.75 12.09 7.75 12.5V21.25Z"
                    fill="#483A9D"
                />
                <path
                    d="M10 18.5C9.59 18.5 9.25 18.16 9.25 17.75V16.25C9.25 15.84 9.59 15.5 10 15.5C10.41 15.5 10.75 15.84 10.75 16.25V17.75C10.75 18.16 10.41 18.5 10 18.5Z"
                    fill="#483A9D"
                />
                <path
                    d="M13.5 8.25H10.5C10.09 8.25 9.75 7.91 9.75 7.5C9.75 7.09 10.09 6.75 10.5 6.75H13.5C13.91 6.75 14.25 7.09 14.25 7.5C14.25 7.91 13.91 8.25 13.5 8.25Z"
                    fill="#483A9D"
                />
              </svg>
              <svg
                  v-else-if="contract.brancheProduit === 'Vie'"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M11.9996 22.7499C11.7096 22.7499 11.4196 22.6499 11.1896 22.4399L7.79961 19.0499H5.99961C2.46961 19.0499 1.24961 16.7599 1.24961 14.0499V5.95C1.24961 3.24 2.46961 0.95 5.99961 0.95H17.9996C21.5296 0.95 22.7496 3.24 22.7496 5.95V14.05C22.7496 16.76 21.5296 19.05 17.9996 19.05H16.1996L12.8096 22.44C12.5796 22.65 12.2896 22.7499 11.9996 22.7499ZM5.99961 2.45C3.20961 2.45 2.74961 3.89 2.74961 5.95V14.05C2.74961 16.11 3.20961 17.55 5.99961 17.55H8.19961C8.47961 17.55 8.74961 17.6599 8.94961 17.8599L11.9996 20.9L15.0496 17.85C15.2596 17.65 15.5296 17.55 15.7996 17.55H17.9996C20.7896 17.55 21.2496 16.11 21.2496 14.05V5.95C21.2496 3.89 20.7896 2.45 17.9996 2.45H5.99961Z"
                    fill="#483A9D"
                />
                <path
                    d="M11.9998 13.0001C11.4098 13.0001 10.9298 12.5201 10.9298 11.9301V11.8701C10.9298 10.8501 11.6398 10.4001 11.9798 10.1901C12.2098 10.0501 12.3798 9.92008 12.3798 9.65008C12.3798 9.27008 12.0698 8.96008 11.6898 8.96008C11.3098 8.96008 10.9998 9.27008 10.9998 9.65008C10.9998 10.2401 10.5198 10.7201 9.92984 10.7201C9.33984 10.7201 8.85986 10.2401 8.85986 9.65008C8.85986 8.1101 10.1099 6.86011 11.6499 6.86011C13.1899 6.86011 14.4398 8.1101 14.4398 9.65008C14.4398 11.0101 13.3798 11.6101 13.0898 11.7801C12.8598 11.9201 13.0398 11.9301 13.0398 11.9301C13.6298 11.9301 14.1098 12.4101 14.1098 13.0001C14.1098 13.5901 13.6298 14.0701 13.0398 14.0701H10.9698C10.3798 14.0701 9.8999 13.5901 9.8999 13.0001C9.8999 12.4101 10.3798 11.9301 10.9698 11.9301L11.9998 13.0001Z"
                    fill="#483A9D"
                />
                <path
                    d="M12 17.5C11.59 17.5 11.25 17.16 11.25 16.75V14.75C11.25 14.34 11.59 14 12 14C12.41 14 12.75 14.34 12.75 14.75V16.75C12.75 17.16 12.41 17.5 12 17.5Z"
                    fill="#483A9D"
                />
              </svg>
            </div>
            <div
                v-if="contract.brancheProduit === 'Automobile'"
                class="police_number d-flex"
                style="margin-top: 15px;"
            >
              <h4>Type :</h4>
              <p>
                {{ contract.brancheProduit }}
              </p>
            </div>

            <div
                v-if="contract.brancheProduit === 'Automobile'"
                class="police_number d-flex"
            >
              <h4>Marque :</h4>
              <p>
                {{ getBrand(contract.listObjetsRisques[0].marqueGenreType) }}
              </p>
            </div>
            <!--                    <div class="police_number d-flex">
                          <h4>{{ $t('CONTRACT_SIDEBAR.AUTOMOBILE.MODEL') }} :</h4>
                          <p>Symbole</p>
                      </div>-->
            <div
                v-if="contract.brancheProduit === 'Automobile'"
                class="police_number d-flex"
            >
              <h4>
                {{ $t('CONTRACT_SIDEBAR.AUTOMOBILE.NUM_IMMATRICULATION') }} :
              </h4>
              <p>{{ contract.listObjetsRisques[0].numeroRisque }}</p>
            </div>

            <div
                v-if="contract.brancheProduit === 'Risques divers' || contract.brancheProduit === 'Incendie'"
                class="police_number d-flex"
                style="margin-top: 15px;"
            >
              <h4>Type :</h4>
              <p>
                {{ contract.brancheProduit }}
              </p>
            </div>

            <div
                v-if="contract.brancheProduit === 'Risques divers' || contract.brancheProduit === 'Incendie'"
                class="police_number d-flex"
            >
              <h4>Produit :</h4>
              <p>
                {{ contract.produit }}
              </p>
            </div>

            <div
                v-if="contract.brancheProduit === 'Risques divers' || contract.brancheProduit === 'Incendie'"
                class="police_number d-flex"
            >
              <h4>Adresse :</h4>
              <p>
                {{ contract.listObjetsRisques[0].marqueGenreType }}
              </p>
            </div>

            <div
                v-if="contract.brancheProduit === 'Risques divers' || contract.brancheProduit === 'Incendie' && contract.listObjetsRisques[0].numeroRisque"
                class="police_number d-flex"
            >
              <h4>N° Risque :</h4>
              <p>
                {{ contract.listObjetsRisques[0].numeroRisque }}
              </p>
            </div>

            <div
                v-if="contract.brancheProduit === 'Vie'"
                class="police_number d-flex"
                style="margin-top: 15px;"
            >
              <h4>Type :</h4>
              <p>
                {{ contract.brancheProduit }}
              </p>
            </div>

            <div
                v-if="contract.brancheProduit === 'Vie'"
                class="police_number d-flex"
            >
              <h4>Produit :</h4>
              <p>
                {{ contract.produit }}
              </p>
            </div>

            <div
                v-if="contract.brancheProduit === 'Vie'"
                class="police_number d-flex"
            >
              <h4>Adresse :</h4>
              <p>
                {{ contract.listObjetsRisques[0].marqueGenreType }}
              </p>
            </div>

            <div
                v-if="contract.brancheProduit === 'Vie'"
                class="police_number d-flex"
            >
              <h4>N° Risque :</h4>
              <p>
                {{ contract.listObjetsRisques[0].numeroRisque }}
              </p>
            </div>

            <div
                v-if="contract.brancheProduit === 'Vie'"
                class="police_number d-flex"
            >
              <h4>Capital :</h4>
              <p>
                {{ contract.provision || contract.primeTTC || 'N/A' }}
              </p>
            </div>

            <div class="date_block">
              <div class="dates d-flex">
                <h3>Date :</h3>
                <div class="date_debut">
                  <svg
                      width="15"
                      height="16"
                      viewBox="0 0 15 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M4.5112 3.38166C4.21253 3.38166 3.96484 3.13398 3.96484 2.83531V0.649874C3.96484 0.351198 4.21253 0.103516 4.5112 0.103516C4.80988 0.103516 5.05756 0.351198 5.05756 0.649874V2.83531C5.05756 3.13398 4.80988 3.38166 4.5112 3.38166Z"
                        fill="#49CF48"
                    />
                    <path
                        d="M10.3384 3.38166C10.0397 3.38166 9.79199 3.13398 9.79199 2.83531V0.649874C9.79199 0.351198 10.0397 0.103516 10.3384 0.103516C10.637 0.103516 10.8847 0.351198 10.8847 0.649874V2.83531C10.8847 3.13398 10.637 3.38166 10.3384 3.38166Z"
                        fill="#49CF48"
                    />
                    <path
                        d="M13.617 6.36127H1.23288C0.934206 6.36127 0.686523 6.11359 0.686523 5.81491C0.686523 5.51624 0.934206 5.26855 1.23288 5.26855H13.617C13.9157 5.26855 14.1634 5.51624 14.1634 5.81491C14.1634 6.11359 13.9157 6.36127 13.617 6.36127Z"
                        fill="#49CF48"
                    />
                    <path
                        d="M10.3388 15.7658H4.51101C1.85207 15.7658 0.322266 14.236 0.322266 11.5771V5.38504C0.322266 2.72609 1.85207 1.19629 4.51101 1.19629H10.3388C12.9978 1.19629 14.5276 2.72609 14.5276 5.38504V11.5771C14.5276 14.236 12.9978 15.7658 10.3388 15.7658ZM4.51101 2.28901C2.42757 2.28901 1.41498 3.30159 1.41498 5.38504V11.5771C1.41498 13.6605 2.42757 14.6731 4.51101 14.6731H10.3388C12.4223 14.6731 13.4349 13.6605 13.4349 11.5771V5.38504C13.4349 3.30159 12.4223 2.28901 10.3388 2.28901H4.51101Z"
                        fill="#49CF48"
                    />
                    <path
                        d="M4.87496 9.75579C4.78026 9.75579 4.68555 9.73395 4.59814 9.69752C4.51072 9.6611 4.4306 9.61009 4.35775 9.54453C4.29219 9.47168 4.24118 9.39156 4.20475 9.30414C4.16833 9.21672 4.14648 9.12202 4.14648 9.02731C4.14648 8.83791 4.22662 8.64851 4.35775 8.5101C4.4306 8.44454 4.51072 8.39353 4.59814 8.35711C4.72926 8.29883 4.87497 8.28426 5.02067 8.3134C5.06438 8.32068 5.10808 8.33525 5.15179 8.35711C5.1955 8.37167 5.2392 8.39355 5.28291 8.42269C5.31933 8.45183 5.35575 8.48096 5.39217 8.5101C5.42131 8.54653 5.45773 8.58294 5.47959 8.61937C5.50873 8.66308 5.5306 8.70678 5.54517 8.75049C5.56703 8.7942 5.58159 8.8379 5.58888 8.88161C5.59616 8.9326 5.60344 8.97632 5.60344 9.02731C5.60344 9.21672 5.5233 9.40612 5.39217 9.54453C5.25376 9.67565 5.06437 9.75579 4.87496 9.75579Z"
                        fill="#49CF48"
                    />
                    <path
                        d="M7.42477 9.75596C7.23536 9.75596 7.04596 9.67582 6.90755 9.54469C6.87841 9.50827 6.84928 9.47185 6.82014 9.43542C6.791 9.39172 6.76913 9.34801 6.75456 9.3043C6.7327 9.26059 6.71814 9.21689 6.71085 9.17318C6.70357 9.12219 6.69629 9.07847 6.69629 9.02748C6.69629 8.93278 6.71813 8.83807 6.75456 8.75065C6.79098 8.66324 6.84199 8.58311 6.90755 8.51027C7.11153 8.30629 7.43934 8.24071 7.70159 8.35727C7.79629 8.39369 7.86913 8.4447 7.94198 8.51027C8.07311 8.64868 8.15324 8.83807 8.15324 9.02748C8.15324 9.07847 8.14597 9.12219 8.13868 9.17318C8.1314 9.21689 8.11683 9.26059 8.09498 9.3043C8.08041 9.34801 8.05853 9.39172 8.02939 9.43542C8.00025 9.47185 7.97112 9.50827 7.94198 9.54469C7.86913 9.61025 7.79629 9.66126 7.70159 9.69769C7.61417 9.73411 7.51947 9.75596 7.42477 9.75596Z"
                        fill="#49CF48"
                    />
                    <path
                        d="M4.87496 12.3058C4.78026 12.3058 4.68555 12.2839 4.59814 12.2475C4.51072 12.2111 4.4306 12.1601 4.35775 12.0945C4.29219 12.0216 4.24118 11.9488 4.20475 11.8541C4.16833 11.7667 4.14648 11.672 4.14648 11.5773C4.14648 11.3879 4.22662 11.1985 4.35775 11.0601C4.4306 10.9945 4.51072 10.9435 4.59814 10.9071C4.86767 10.7905 5.1882 10.8561 5.39217 11.0601C5.42131 11.0965 5.45773 11.1329 5.47959 11.1693C5.50873 11.213 5.5306 11.2567 5.54517 11.3005C5.56703 11.3442 5.58159 11.3879 5.58888 11.4389C5.59616 11.4826 5.60344 11.5336 5.60344 11.5773C5.60344 11.7667 5.5233 11.9561 5.39217 12.0945C5.25376 12.2256 5.06437 12.3058 4.87496 12.3058Z"
                        fill="#49CF48"
                    />
                  </svg>
                  <span>{{ contract.DateEffet }}</span>
                </div>
                <div class="date_fin">
                  <svg
                      width="15"
                      height="16"
                      viewBox="0 0 15 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M4.5112 3.38166C4.21253 3.38166 3.96484 3.13398 3.96484 2.83531V0.649874C3.96484 0.351198 4.21253 0.103516 4.5112 0.103516C4.80988 0.103516 5.05756 0.351198 5.05756 0.649874V2.83531C5.05756 3.13398 4.80988 3.38166 4.5112 3.38166Z"
                        fill="#FA3559"
                    />
                    <path
                        d="M10.3384 3.38166C10.0397 3.38166 9.79199 3.13398 9.79199 2.83531V0.649874C9.79199 0.351198 10.0397 0.103516 10.3384 0.103516C10.637 0.103516 10.8847 0.351198 10.8847 0.649874V2.83531C10.8847 3.13398 10.637 3.38166 10.3384 3.38166Z"
                        fill="#FA3559"
                    />
                    <path
                        d="M13.617 6.36127H1.23288C0.934206 6.36127 0.686523 6.11359 0.686523 5.81491C0.686523 5.51624 0.934206 5.26855 1.23288 5.26855H13.617C13.9157 5.26855 14.1634 5.51624 14.1634 5.81491C14.1634 6.11359 13.9157 6.36127 13.617 6.36127Z"
                        fill="#FA3559"
                    />
                    <path
                        d="M10.3388 15.7658H4.51101C1.85207 15.7658 0.322266 14.236 0.322266 11.5771V5.38504C0.322266 2.72609 1.85207 1.19629 4.51101 1.19629H10.3388C12.9978 1.19629 14.5276 2.72609 14.5276 5.38504V11.5771C14.5276 14.236 12.9978 15.7658 10.3388 15.7658ZM4.51101 2.28901C2.42757 2.28901 1.41498 3.30159 1.41498 5.38504V11.5771C1.41498 13.6605 2.42757 14.6731 4.51101 14.6731H10.3388C12.4223 14.6731 13.4349 13.6605 13.4349 11.5771V5.38504C13.4349 3.30159 12.4223 2.28901 10.3388 2.28901H4.51101Z"
                        fill="#FA3559"
                    />
                    <path
                        d="M4.87496 9.75579C4.78026 9.75579 4.68555 9.73395 4.59814 9.69752C4.51072 9.6611 4.4306 9.61009 4.35775 9.54453C4.29219 9.47168 4.24118 9.39156 4.20475 9.30414C4.16833 9.21672 4.14648 9.12202 4.14648 9.02731C4.14648 8.83791 4.22662 8.64851 4.35775 8.5101C4.4306 8.44454 4.51072 8.39353 4.59814 8.35711C4.72926 8.29883 4.87497 8.28426 5.02067 8.3134C5.06438 8.32068 5.10808 8.33525 5.15179 8.35711C5.1955 8.37167 5.2392 8.39355 5.28291 8.42269C5.31933 8.45183 5.35575 8.48096 5.39217 8.5101C5.42131 8.54653 5.45773 8.58294 5.47959 8.61937C5.50873 8.66308 5.5306 8.70678 5.54517 8.75049C5.56703 8.7942 5.58159 8.8379 5.58888 8.88161C5.59616 8.9326 5.60344 8.97632 5.60344 9.02731C5.60344 9.21672 5.5233 9.40612 5.39217 9.54453C5.25376 9.67565 5.06437 9.75579 4.87496 9.75579Z"
                        fill="#FA3559"
                    />
                    <path
                        d="M7.42477 9.75596C7.23536 9.75596 7.04596 9.67582 6.90755 9.54469C6.87841 9.50827 6.84928 9.47185 6.82014 9.43542C6.791 9.39172 6.76913 9.34801 6.75456 9.3043C6.7327 9.26059 6.71814 9.21689 6.71085 9.17318C6.70357 9.12219 6.69629 9.07847 6.69629 9.02748C6.69629 8.93278 6.71813 8.83807 6.75456 8.75065C6.79098 8.66324 6.84199 8.58311 6.90755 8.51027C7.11153 8.30629 7.43934 8.24071 7.70159 8.35727C7.79629 8.39369 7.86913 8.4447 7.94198 8.51027C8.07311 8.64868 8.15324 8.83807 8.15324 9.02748C8.15324 9.07847 8.14597 9.12219 8.13868 9.17318C8.1314 9.21689 8.11683 9.26059 8.09498 9.3043C8.08041 9.34801 8.05853 9.39172 8.02939 9.43542C8.00025 9.47185 7.97112 9.50827 7.94198 9.54469C7.86913 9.61025 7.79629 9.66126 7.70159 9.69769C7.61417 9.73411 7.51947 9.75596 7.42477 9.75596Z"
                        fill="#FA3559"
                    />
                    <path
                        d="M4.87496 12.3058C4.78026 12.3058 4.68555 12.2839 4.59814 12.2475C4.51072 12.2111 4.4306 12.1601 4.35775 12.0945C4.29219 12.0216 4.24118 11.9488 4.20475 11.8541C4.16833 11.7667 4.14648 11.672 4.14648 11.5773C4.14648 11.3879 4.22662 11.1985 4.35775 11.0601C4.4306 10.9945 4.51072 10.9435 4.59814 10.9071C4.86767 10.7905 5.1882 10.8561 5.39217 11.0601C5.42131 11.0965 5.45773 11.1329 5.47959 11.1693C5.50873 11.213 5.5306 11.2567 5.54517 11.3005C5.56703 11.3442 5.58159 11.3879 5.58888 11.4389C5.59616 11.4826 5.60344 11.5336 5.60344 11.5773C5.60344 11.7667 5.5233 11.9561 5.39217 12.0945C5.25376 12.2256 5.06437 12.3058 4.87496 12.3058Z"
                        fill="#FA3559"
                    />
                  </svg>
                  <span>{{ contract.dateEcheance }}</span>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <woot-modal
        :show.sync="showModal"
        :on-close="closeAdvanceFiltersModal"
        size="overflow"
    >
      <div class="column">
        <woot-modal-header :header-title="$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.TITLE')" />
        <div class="column modal-content">
          <div class="medium-12 columns filters-wrap">
            <div class="filters">
              <div class="filter-inputs">
                <multiselect-dropdown
                    :options="filterTypesList"
                    :selected-item="currentSelectedType"
                    :multiselector-title="$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.TYPE.TITLE')"
                    :multiselector-placeholder="$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.TYPE.ALL_TYPES')"
                    :has-thumbnail="false"
                    :is-contract="true"
                    @click="changeFilterType"
                />
                <multiselect-dropdown
                    v-if="currentSelectedType.value === 0"
                    :selected-item="currentSelectedAnswer"
                    :multiselector-title="$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.ALL')"
                    :multiselector-placeholder="$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.ALL')"
                    :all="true"
                    :has-thumbnail="false"
                    :is-filter-contract="true"
                />
                <multiselect-dropdown
                    v-else-if="currentSelectedType.value === 1"
                    :options="automobileList"
                    :selected-item="currentSelectedAutoAnswer"
                    :multiselector-title="$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.AUTOMOBILE.TITLE')"
                    :multiselector-placeholder="$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.AUTOMOBILE.PLACEHOLDER')"
                    :has-thumbnail="false"
                    :is-filter-contract="true"
                    @click="changeFilterImmat"
                />
                <multiselect-dropdown
                    v-else-if="currentSelectedType.value === 2"
                    :options="addressList"
                    :selected-item="currentSelectedAddressAnswer"
                    :multiselector-title="$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.MRH.TITLE')"
                    :multiselector-placeholder="$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.MRH.PLACEHOLDER')"
                    :has-thumbnail="false"
                    :is-filter-contract="true"
                    @click="changeFilterAddress"
                />
                <woot-button
                    v-tooltip="$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.CLEAR_FILTER')"
                    icon="dismiss"
                    variant="clear"
                    color-scheme="secondary"
                    @click="removeFilter"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="medium-12 columns">
          <div class="modal-footer justify-content-end w-full">
            <woot-button class="button clear" @click.prevent="closeAdvanceFiltersModal">
              {{ $t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.CANCEL') }}
            </woot-button>
            <woot-button :disabled="disabledButton" style="margin-right: 1rem" @click="submitFilterQuery">
              {{ $t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.APPLY') }}
            </woot-button>
          </div>
        </div>
      </div>
    </woot-modal>
  </div>
</template>

<script>
import MultiselectDropdown from 'shared/components/ui/MultiselectDropdown.vue' ;
export default {
  name: 'Contracts',
  components: {
    MultiselectDropdown,
  },
  data() {
    return {
      updatedContracts: [],
      showFiltersModal: false,
      appliedFilter: {type: 'all', value: 'all'},
      filterTypesList: [
        {value: 0, name: this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.TYPE.ALL_TYPES')},
        {value: 1, name: this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.TYPE.AUTOMOBILE')},
        {value: 2, name: this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.TYPE.MRH')}
      ],
      currentSelectedType: {value: 0, name: this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.TYPE.ALL_TYPES')},
      currentSelectedAutoAnswer: {name: this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.AUTOMOBILE.PLACEHOLDER') },
      currentSelectedAddressAnswer: {name: this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.MRH.PLACEHOLDER') },
      currentSelectedAnswer: { name: this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.ALL') },
    };
  },
  props: {
    clientAllContracts: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    disabledButton() {
      if ((this.currentSelectedType.value === 0) ||
          (this.currentSelectedType.value === 1 && this.currentSelectedAutoAnswer.name !== this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.AUTOMOBILE.PLACEHOLDER'))
          || this.currentSelectedType.value === 2 && this.currentSelectedAddressAnswer.name !== this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.MRH.PLACEHOLDER')) {
        return false;
      }
      else {
        return true;
      }
    },
    filteredContracts() {
      if (this.appliedFilter.type === 'all') {
        return this.updatedContracts;
      }
      else if (this.appliedFilter.type === 'Automobile') {
        const autoContracts = [];
        this.updatedContracts.forEach(contract => {
          if (contract.brancheProduit === 'Automobile' && contract.listObjetsRisques && contract.listObjetsRisques.some(obj => obj.numeroRisque === this.appliedFilter.value)) {
            autoContracts.push(contract);
          }
        });
        return autoContracts;
      }
      else if (this.appliedFilter.type === 'Habitation') {
        const habitationContracts = [];
        this.updatedContracts.forEach(contract => {
          if ((contract.brancheProduit === 'Risques divers' || contract.brancheProduit === 'Incendie' || contract.brancheProduit === 'Vie') &&
              contract.listObjetsRisques && contract.listObjetsRisques.length > 0) {

            // Check if any risk in the contract matches the address filter
            const matchesAddress = this.appliedFilter.value === 'all' ||
                contract.listObjetsRisques.some(risk => {
                  if (risk.marqueGenreType) {
                    const address = this.getAddress(risk.marqueGenreType);
                    return address === this.appliedFilter.value;
                  }
                  return false;
                });

            if (matchesAddress) {
              habitationContracts.push(contract);
            }
          }
        });
        return habitationContracts;
      }
    },
    showModal() {
      return this.showFiltersModal ;
    },
    automobileList() {
      return this.updatedContracts
          .filter(contract => contract.brancheProduit === "Automobile")
          .map(contract => {
            return { name: contract.listObjetsRisques[0].numeroRisque };
          });
    },
    addressList() {
      // Create a unique list of addresses from all contract types
      const addressMap = new Map();

      this.updatedContracts
          .filter(contract => contract.brancheProduit === "Risques divers" || contract.brancheProduit === "Incendie" || contract.brancheProduit === "Vie")
          .forEach(contract => {
            if (contract.listObjetsRisques && contract.listObjetsRisques.length > 0) {
              contract.listObjetsRisques.forEach(risk => {
                if (risk.marqueGenreType) {
                  const name = this.getAddress(risk.marqueGenreType);
                  if (name && name.length > 0) {
                    addressMap.set(name, { name });
                  }
                }
              });
            }
          });

      // Convert map to array for the dropdown
      return Array.from(addressMap.values());
    },
  },
  mounted() {
    this.filterContracts();
  },

  methods: {
    async filterContracts() {
      for (const contract of this.clientAllContracts) {
        let redirectUrl = '';
        if (contract.listObjetsRisques.length > 1) {
          for (const objet of contract.listObjetsRisques) {
            redirectUrl = await this.getRedirectUrl(contract.numPolice);
            this.updatedContracts.push({
              ...contract,
              listObjetsRisques: [objet],
              redirectUrl: redirectUrl,
            });
          }
        } else {
          redirectUrl = await this.getRedirectUrl(contract.numPolice);
          this.updatedContracts.push({
            ...contract,
            redirectUrl: redirectUrl,
          });
        }
      }
    },
    getBrand(marqueGenreType) {
      const startIndex = 10;
      // Finds the first '/' or space after position 10
      const endIndex =
          marqueGenreType.indexOf('/', startIndex) !== -1
              ? marqueGenreType.indexOf('/', startIndex)
              : marqueGenreType.indexOf(' ', startIndex);
      // Extract text from position 10 to just before the first '/' or space
      const marque =
          endIndex !== -1
              ? marqueGenreType.substring(startIndex, endIndex)
              : marqueGenreType.substring(startIndex);
      return marque;
    },
    getAddress(marqueGenreType) {
      if (!marqueGenreType) return '';

      // For Vie contracts and others, just return the full string to avoid losing information
      return marqueGenreType.trim();
    },
    async getRedirectUrl(numContract) {
      const { appLogicURL } = window.convergenceConfig;
      const response = await axios.get(`${appLogicURL}/gat/ticketUrl`, {
        params: {
          numero: numContract,
        },
      });
      let redirectUrl = response.data.RedirectUrl;
      return redirectUrl;
    },
    onToggleFilters() {
      this.showFiltersModal = true;
    },
    closeAdvanceFiltersModal() {
      this.showFiltersModal = false;
    },
    changeFilterType(option) {
      if ((this.currentSelectedType) && (this.currentSelectedType.value === option.value)) {
        this.currentSelectedType = {
          value: 0,
          name: this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.TYPE.ALL_TYPES'),
        };
      } else {
        this.currentSelectedType = option ;
      }
      this.currentSelectedAutoAnswer = {
        name: this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.AUTOMOBILE.PLACEHOLDER'),
      };
      this.currentSelectedAddressAnswer = {
        name: this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.MRH.PLACEHOLDER'),
      };
    },
    onFilterTypeChange() {
      if (this.currentSelectedType.value === 1) {
        this.appliedFilter.type = 'Automobile';
      }
      else if (this.currentSelectedType.value === 2) {
        this.appliedFilter.type = 'Habitation'
      }
      else {
        this.appliedFilter.type = 'all';
      }
    },
    changeFilterImmat(option) {
      if ((this.currentSelectedAutoAnswer) && (this.currentSelectedAutoAnswer.name === option.name)) {
        this.currentSelectedAutoAnswer = {
          name: this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.AUTOMOBILE.PLACEHOLDER'),
        };
      } else {
        this.currentSelectedAutoAnswer = option ;
      }
    },
    onFilterAutoChange() {
      if (this.currentSelectedAutoAnswer.name !== this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.AUTOMOBILE.PLACEHOLDER')) {
        this.appliedFilter.value = this.currentSelectedAutoAnswer.name;
      }
    },
    changeFilterAddress(option) {
      if ((this.currentSelectedAddressAnswer) && (this.currentSelectedAddressAnswer.name === option.name)) {
        this.currentSelectedAddressAnswer = { name: this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.MRH.PLACEHOLDER') };
      } else {
        this.currentSelectedAddressAnswer = option;
      }
      console.log('Selected address:', option.name);
    },
    onFilterAddressChange() {
      if (this.currentSelectedAddressAnswer.name !== this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.MRH.PLACEHOLDER')) {
        this.appliedFilter.value = this.currentSelectedAddressAnswer.name;
      } else {
        this.appliedFilter.value = 'all';
      }
    },
    submitFilterQuery() {
      this.onFilterTypeChange();
      this.onFilterAutoChange();
      this.onFilterAddressChange();
      this.closeAdvanceFiltersModal();
    },
    removeFilter() {
      this.currentSelectedType = {
        value: 0,
        name: this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.TYPE.ALL_TYPES'),
      };
      this.currentSelectedAutoAnswer = {
        name: this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.AUTOMOBILE.PLACEHOLDER'),
      };
      this.currentSelectedAddressAnswer = {
        name: this.$t('CONTRACT_SIDEBAR.CONTRACTS_FILTER.ANSWER.MRH.PLACEHOLDER'),
      };
    },
  },
};
</script>

<style scoped lang="scss">
.contracts {
  padding: 8px;

  .contract_btn {
    cursor: pointer;
    background: #483a9d;
    border-radius: 8px;
    height: 45px;
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 24px;
    text-align: center;
    width: 100%;
    margin-bottom: 12px;
    color: white;
  }

  .contract_action {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .contract_title {
    font-size: large;
    font-weight: 500;
    color: #676776;
    margin-left: 1rem;
  }

  .contract_card {
    background: #ffffff;
    /*box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);*/
    border-radius: 8px;
    padding: 12px;
    border: 0.5px solid #dad7ea;

    .contract_header {
      justify-content: space-between;
      margin-bottom: 12px;

      h3 {
        font-style: normal;
        font-weight: 500;
        font-size: 16.1259px;
        line-height: 20px;
        color: #483a9d;
        margin-top: 3px !important;
      }

      .type_badge {
        padding: 6px 10px;
        font-style: normal;
        font-weight: 500;
        font-size: 12.4327px;
        line-height: 15px;
      }

      .accepted {
        color: #49cf48 !important;
        background: #f4fbf5 !important;
        border: 1px solid #49cf48 !important;
        border-radius: 5px !important;
      }

      .pending {
        color: #f8ab26 !important;
        background: #fffbf4 !important;
        border: 1px solid #f8ab26 !important;
        border-radius: 5px !important;
      }

      .suspended {
        color: #fa3559 !important;
        background: #fff2f2 !important;
        border: 1px solid #fa3559 !important;
        border-radius: 5px !important;
      }
    }

    .contract_body {
      background: #f5f5f5;
      box-shadow: 0px 3.45556px 11.5185px rgba(0, 0, 0, 0.05);
      border-radius: 5.75926px;
      padding: 10px 8px;

      .num_contract {
        justify-content: space-between;
        padding: 0 0 5px 0;
        border-bottom: 1px solid #a49dcf;

        h4 {
          font-style: normal !important;
          font-weight: 501 !important;
          font-size: 14.9246px !important;
          line-height: 18px !important;
          letter-spacing: 0.1em !important;
          margin-top: 4px;
        }

        svg {
          opacity: 0.6;
          margin-top: -5px;
        }
      }

      .police_number {
        justify-content: space-between;

        h4 {
          font-style: normal !important;
          font-weight: 500 !important;
          font-size: 13.4687px !important;
          line-height: 16px !important;
          color: #656877 !important;
        }

        p {
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          color: #656877;
        }
      }

      .date_block {
        margin-top: 2rem;
        h3 {
          font-style: normal !important;
          font-weight: 571 !important;
          font-size: 13.4687px !important;
          line-height: 16px !important;
          color: #483a9d !important;
        }

        .dates {
          justify-content: space-between;
          margin-top: 2px;

          .date_debut {
            display: flex;

            span {
              margin-left: 5px;
              font-style: normal;
              font-weight: 400;
              font-size: 13px;
              line-height: 14px;
              color: #656877;
              margin-top: 2px;
            }

            svg {
              opacity: 0.6;
            }
          }

          .date_fin {
            display: flex;

            span {
              margin-left: 5px;
              font-style: normal;
              font-weight: 400;
              font-size: 13px;
              line-height: 14px;
              color: #656877;
              margin-top: 2px;
            }

            svg {
              opacity: 0.6;
            }
          }
        }
      }
    }
  }
}

.no-contracts {
  display: flex;
  justify-content: space-around;
  margin-top: 50%;
  font-size: large;
  font-weight: 500;
  color: #676776;
}

.filters-wrap {
  padding: var(--space-normal);
  border-radius: var(--border-radius-large);
  border: 1px solid var(--color-border);
  background: var(--color-background-light);
  margin-bottom: var(--space-normal);
}

.filter-inputs {
  display: flex;
}
</style>
